import styled from 'styled-components';
import { TeamColor } from '@algoan/dashboard/model';
import { TeamIcon } from '../../shared-components/icons';

export const TeamCell: React.FC<{ teamName: string; teamColor?: TeamColor; isAnonymousCustomer: boolean }> = ({
  teamName,
  teamColor,
  isAnonymousCustomer,
}) => {
  return (
    <S.TeamCell>
      <S.TeamIconContainer isAnonymousCustomer={isAnonymousCustomer}>
        <TeamIcon color={teamColor} />
      </S.TeamIconContainer>
      <S.TeamLabelContainer>{teamName}</S.TeamLabelContainer>
    </S.TeamCell>
  );
};

const S = {
  TeamIconContainer: styled.div<{ isAnonymousCustomer: boolean }>`
    margin-right: 9px;
    margin-top: 3px;
    opacity: ${(props) => (props.isAnonymousCustomer ? '0.35' : '1')};
  `,
  TeamCell: styled.div`
    display: flex;
  `,
  TeamLabelContainer: styled.div`
    margin-top: 3px;
  `,
};
